import axios from 'axios'
import qs from 'qs'
import { Toast } from 'vant'
// 定义一个混入对象
import { methodMixin } from '../mixins'
import store from '../store' //仓库
import Vue from 'vue'
// 定义一个使用混入对象的组件
var myComponent = Vue.extend({
  store,
  mixins: [methodMixin]
})
// 定义context为混入对象，通过context.$loading调用接口loading方法
var context = new myComponent()

console.log(process.env.VUE_APP_BASE_URL)

axios.defaults.timeout = 60000
// axios.defaults.baseURL = envBaseUrls[process.env.NODE_ENV]
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL
axios.defaults.withCredentials = true

//http request 拦截器 请求拦截（配置发送请求的信息）
axios.interceptors.request.use(
  config => {
    // 自动附加 access-token
    try {
      const token =
        (store && store.getters && store.getters.userInfo && store.getters.userInfo.token) ||
        window.localStorage.getItem('access-token')
      if (token) {
        config.headers = config.headers || {}
        // 兼容后端不同的鉴权头字段命名
        config.headers['access-token'] = token
        config.headers['Authorization'] = `Bearer ${token}`
        config.headers['token'] = token
      }
    } catch (e) {
      console.log(e)
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

//http response 拦截器 响应拦截（配置请求回来的信息）
axios.interceptors.response.use(
  response => {
    const data = response.data
    // 支持两种响应格式：{ success } 或 { code, message }
    if (data && typeof data === 'object') {
      if (Object.prototype.hasOwnProperty.call(data, 'success')) {
        if (!data.success) {
          Toast(
            (data && data.messages && data.messages[0]) ||
              (data && data.actionErrors && data.actionErrors[0]) ||
              '请求失败'
          )
          return Promise.reject(data)
        }
      } else if (Object.prototype.hasOwnProperty.call(data, 'code')) {
        if (data.code !== 200) {
          Toast(data.message || data.error || '请求失败')
          return Promise.reject(data)
        }
      }
    }
    return response
  },
  error => {
    Toast('请求失败，请稍后再试')
    context.$loading(false, true)
    // 处理响应失败
    // if (error.response.code == 501) {
    //   Toast.fail('未授权，请重新登录')
    //   router.push('/mine')
    // } else if (error.response.status == 401) {
    //   router.push('/mine')
    // }
    // redirect()
    return Promise.reject(error)
  }
)

// const setHeader = needToken => {
//   const token = window.localStorage.getItem('RMWL-JEECMS-Auth-Token')
//   const config = {
//     headers: needToken
//       ? {
//           'Content-Type': 'application/json',
//           'JEECMS-Auth-Token': token
//         }
//       : {
//           'Content-Type': 'application/json'
//         }
//   }

//   return config
// }

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    context.$loading(true, false)
    axios
      .get(url, {
        params: params,
        paramsSerializer: params => {
          return qs.stringify(params, { indices: false })
        }
      })
      .then(response => {
        const data = response.data
        if ((data && data.success === true) || (data && data.code === 200)) {
          resolve(data)
        } else {
          reject(response)
        }
        context.$loading(false, false)
      })
      .catch(err => {
        context.$loading(false, true)
        reject(err)
      })
  })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}, config = {}) {
  return new Promise((resolve, reject) => {
    context.$loading(true, false)
    axios
      .post(url, data, config)
      .then(response => {
        const resData = response.data
        if ((response.status == 200 && resData && resData.success === true) || (resData && resData.code === 200)) {
          resolve(resData)
        } else {
          reject(response)
        }
        context.$loading(false, false)
      })
      .catch(err => {
        reject(err)
        context.$loading(false, true)
      })
  })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, params = {}) {
  return new Promise((resolve, reject) => {
    context.$loading(true, false)
    // console.warn(params)
    axios
      .patch(url, {
        params: params
      })
      .then(response => {
        if (response.data.success) {
          resolve(response.data)
        } else {
          reject(response)
        }
        context.$loading(false, false)
      })
      .catch(err => {
        context.$loading(false, true)
        reject(err)
      })
  })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, params = {}) {
  return new Promise((resolve, reject) => {
    context.$loading(true, false)
    // console.warn(params)
    axios
      .put(url, params)
      .then(response => {
        if (response.data.success) {
          resolve(response.data)
        } else {
          reject(response)
        }
        context.$loading(false, false)
      })
      .catch(err => {
        context.$loading(false, true)
        reject(err)
      })
  })
}

/**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function del(url, params = {}) {
  return new Promise((resolve, reject) => {
    context.$loading(true, false)
    // console.warn(params)
    axios
      .delete(url, {
        params: params
      })
      .then(response => {
        if (response.data.success) {
          resolve(response.data)
        } else {
          reject(response)
        }
        context.$loading(false, false)
      })
      .catch(err => {
        context.$loading(false, true)
        reject(err)
      })
  })
}

export const baseURL = axios.defaults.baseURL
